import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

import { LoginService } from '../../../Authentication/auth/login.service';
import { UserService } from '../../../../services/user';
import { PetServices } from '../../../../services/petservices';

@Component({
  selector: 'app-myclinicservices',
  templateUrl: './myclinicservices.component.html',
  styleUrl: './myclinicservices.component.scss'
})
export class MyclinicservicesComponent implements OnInit {

  contentReady = false;
  noData = false;

  isAr = false;
  tokenExists = false;

  allData: any[] = [];
  bookingsTotal: any = 0;

  page = 1;
  perPage = 10;

  clinicPhone: string = '01149444701';

  private isBrowser: boolean;

  constructor(
    private _petServices: PetServices,
    private _LoginService: LoginService,
    private _userService: UserService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.checkForToken();
  }

  // ================= AUTH =================

  checkForToken(): void {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;

      if (this.tokenExists) {
        this.getUserClinicBookings(1);
      } else {
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  // ================= DATA =================

  getUserClinicBookings(page: number = 1): void {
    this.contentReady = true;
    this.page = page;

    this._userService.getUserId().subscribe({
      next: (data) => {
        this._petServices.getBookingsByUser(data.user_id, page, this.perPage).subscribe({
          next: (res) => {
            this.allData = res?.data || [];
            this.bookingsTotal = res?.total || this.allData.length;

            this.noData = this.allData.length === 0;
            this.contentReady = false;
          },
          error: (error) => {
            console.error('Bookings error:', error);
            this.allData = [];
            this.noData = true;
            this.contentReady = false;
          }
        });
      },
      error: (error) => {
        console.error('User id error:', error);
        this.allData = [];
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  // ================= SERVICE HELPERS =================

  getService(booking: any): any {
    return booking?.pet_service || booking?.petService || booking?.service || null;
  }

  getServiceImage(booking: any): string | null {
    const service = this.getService(booking);

    return service?.image_url
      || service?.image
      || service?.photo
      || null;
  }

  getServiceName(booking: any): string {
    const service = this.getService(booking);

    if (this.isAr) {
      return service?.name_ar
        || service?.title_ar
        || service?.name
        || 'خدمة عيادة';
    }

    return service?.name_en
      || service?.title_en
      || service?.name
      || 'Clinic Service';
  }

  getServicePrice(booking: any): any {
    const service = this.getService(booking);

    return  service?.pricea

  }

  // ================= PET TYPE =================

  getPetTypeLabel(type: any): string {
    const value = String(type ?? '').toLowerCase();

    if (this.isAr) {
      if (value === '0' || value === 'cat' || value === 'cats') return 'قطط';
      if (value === '1' || value === 'dog' || value === 'dogs') return 'كلاب';
      if (value === '2' || value === 'bird' || value === 'birds') return 'طيور';
      if (value === '4' || value === 'catsanddogs' || value === 'cats&dogs') return 'قطط وكلاب';

      return type || '-';
    }

    if (value === '0' || value === 'cat' || value === 'cats') return 'Cats';
    if (value === '1' || value === 'dog' || value === 'dogs') return 'Dogs';
    if (value === '2' || value === 'bird' || value === 'birds') return 'Birds';
    if (value === '4' || value === 'catsanddogs' || value === 'cats&dogs') return 'Cats & Dogs';

    return type || '-';
  }

  // ================= STATUS =================

  getStatusLabel(status: any): string {
    const value = Number(status);

    if (this.isAr) {
      switch (value) {
        case 0:
          return 'قيد المراجعة';
        case 1:
          return 'تم تأكيد الحجز';
        case 2:
          return 'تم إلغاء الحجز';
        case 3:
          return 'تم تأجيل الحجز';
        case 4:
          return 'تم اكتمال الحجز';
        default:
          return 'تم الحجز';
      }
    }

    switch (value) {
      case 0:
        return 'Pending';
      case 1:
        return 'Confirmed';
      case 2:
        return 'Cancelled';
      case 3:
        return 'Deferred';
      case 4:
        return 'Completed';
      default:
        return 'Booked';
    }
  }

  getStatusClass(status: any): string {
    const value = Number(status);

    switch (value) {
      case 0:
        return 'status-pending';
      case 1:
        return 'status-approved order-status-approved';
      case 2:
        return 'status-rejected';
      case 3:
        return 'status-deferred';
      case 4:
        return 'status-completed';
      default:
        return 'status-approved order-status-approved';
    }
  }

  isDeferredBooking(booking: any): boolean {
    return Number(booking?.status) === 3 && !!booking?.deferred_booking_date;
  }

  canCancelBooking(booking: any): boolean {
    const status = Number(booking?.status);

    // rejected أو completed مفيش إلغاء
    return status !== 2 && status !== 4;
  }

  cancelBooking(bookingId: number): void {
    if (!bookingId) return;

    const message = this.isAr
      ? 'هل أنت متأكد من إلغاء الحجز؟'
      : 'Are you sure you want to cancel this booking?';

    if (this.isBrowser && !window.confirm(message)) {
      return;
    }

    this.contentReady = true;

    this._petServices.updateBookingStatus(bookingId, {
      status: 2
    }).subscribe({
      next: () => {
        this.getUserClinicBookings(this.page);
      },
      error: (error) => {
        console.error('Cancel booking error:', error);
        this.contentReady = false;
      }
    });
  }

  // ================= DATE =================

convertDateTime(date: any): string {
  if (!date) return '-';

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return '-';
  }

  // ✅ نقص 3 ساعات من التاريخ المعروض
  parsedDate.setHours(parsedDate.getHours() - 3);

  return parsedDate.toLocaleString(this.isAr ? 'ar-EG' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

  // ================= ACTIONS =================

  callClinic(): void {
    if (!this.isBrowser) return;

    window.location.href = `tel:${this.clinicPhone}`;
  }

  chatClinic(): void {
    if (!this.isBrowser) return;

    window.open(`https://wa.me/2${this.clinicPhone}`, '_blank');
  }

  goBack(): void {
    if (!this.isBrowser) return;

    history.back();
  }
}